(function () {
  'use strict';

  const cfg = (function () {
    try {
      return JSON.parse(document.getElementById('cd-config')?.textContent || '{}');
    } catch (_) {
      return {};
    }
  })();

  // 2026-10-17 QA F16: markets without their own threshold get the USD one converted with Shopify's live rate (was shown unconverted, e.g. "₱110").
  const FX = cfg.thresholdUsd && window.Shopify && Shopify.currency && Number(Shopify.currency.rate);
  const THRESHOLD = FX ? Math.round(Number(cfg.threshold || 11000) * FX) : Number(cfg.threshold || 11000);
  if (FX) setTimeout(function () { fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { try { renderProgress(c); } catch (_) {} }).catch(function () {}); }, 0);
  const PP_VARIANT_FALLBACK = String(cfg.ppVariantId || '');
  const MONEY_FORMAT = String(cfg.moneyFormat || '${{amount}}');
  const H = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  const GIFT_MAX_QTY = 2;

  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('cd-overlay');

  if (!drawer || !overlay) return;

  const itemsList = document.getElementById('cd-items');
  const emptyEl = document.getElementById('cd-empty');
  const footerEl = drawer.querySelector('.cd-footer');
  const pfill = drawer.querySelector('[data-progress-fill]');
  const plabel = drawer.querySelector('[data-progress-label]');
  const sprice = drawer.querySelector('[data-subtotal-price]');
  const scmp = drawer.querySelector('[data-subtotal-compare]');
  const slabel = drawer.querySelector('[data-subtotal-label]');
  const ppBtn = drawer.querySelector('[data-pp-toggle]');
  const dcInput = document.getElementById('cd-dc-input');
  const dcApply = document.getElementById('cd-dc-apply');
  const dcMsg = document.getElementById('cd-dc-msg');

  const defaultPPHandles = ['package-protection', 'free-returns-package-protection-1'];
  const datasetPPHandle = String(drawer.dataset.ppHandle || '').trim().toLowerCase();
  const PP_HANDLES = datasetPPHandle
    ? Array.from(new Set([datasetPPHandle, ...defaultPPHandles]))
    : defaultPPHandles;

  const COMPARE_AT_BY_VARIANT = Object.assign({}, cfg.compareAtPrices || {});
  const PRODUCT_CACHE = {};

  const FIXED_UPSELL_PRICES = Object.assign(
    {
      '47474420154588': {
        handle: 'cleaning-brush',
        basePriceCents: 1000,
        baseCurrency: 'USD'
      }
    },
    cfg.fixedUpsellPrices || {}
  );

  const FIXED_UPSELL_PRICE_CACHE = {};
  let presentmentCurrency = String(
    cfg.currencyCode ||
    (
      window.Shopify &&
      window.Shopify.currency &&
      (window.Shopify.currency.active || window.Shopify.currency.current)
    ) ||
    'USD'
  ).toUpperCase();

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function syncPresentmentCurrency(cart) {
    const currency = cart && (
      cart.currency ||
      cart.presentment_currency ||
      cart.cart_currency
    );

    if (currency) {
      presentmentCurrency = String(currency).toUpperCase();
      return;
    }

    if (window.Shopify && window.Shopify.currency) {
      presentmentCurrency = String(
        window.Shopify.currency.active ||
        window.Shopify.currency.current ||
        presentmentCurrency ||
        'USD'
      ).toUpperCase();
    }
  }

  function getCurrencySymbol(currencyCode) {
    const code = String(currencyCode || getActiveCurrency() || 'USD').toUpperCase();

    const fallbackSymbols = {
      USD: '$',
      CAD: '$',
      AUD: '$',
      NZD: '$',
      EUR: '€',
      GBP: '£',
      PHP: '₱',
      BRL: 'R$',
      JPY: '¥'
    };

    try {
      const parts = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol'
      }).formatToParts(0);

      const symbol = parts.find((part) => part.type === 'currency')?.value;
      return symbol || fallbackSymbols[code] || code;
    } catch (_) {
      return fallbackSymbols[code] || code;
    }
  }

  function money(cents) {
    const value = Number(cents || 0);
    const currency = getActiveCurrency();

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value / 100);
    } catch (_) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(value, MONEY_FORMAT);
      }

      return getCurrencySymbol(currency) + (value / 100).toFixed(2);
    }
  }

  function normalizeDrawerCurrencySymbols(root = drawer) {
    const currency = getActiveCurrency();

    if (currency === 'USD') return;

    const symbol = getCurrencySymbol(currency);
    const selectors = [
      '.cd-p',
      '.cd-p-sale',
      '.cd-p-was',
      '.cd-up-price',
      '.cd-up-price .money',
      '[data-subtotal-price]',
      '[data-subtotal-compare]'
    ];

    root.querySelectorAll(selectors.join(',')).forEach((el) => {
      const current = String(el.textContent || '');

      if (!current.trim()) return;
      if (!/^\s*\$/.test(current)) return;

      el.textContent = current.replace(/^\s*\$/, symbol);
    });
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getActiveCurrency() {
    return String(
      presentmentCurrency ||
      cfg.currencyCode ||
      (
        window.Shopify &&
        window.Shopify.currency &&
        (window.Shopify.currency.active || window.Shopify.currency.current)
      ) ||
      'USD'
    ).toUpperCase();
  }

  function getCurrencyRate() {
    const rate = Number(
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.rate
    );

    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  }

  function getConvertedBasePriceCents(rule) {
    const activeCurrency = String(getActiveCurrency()).toUpperCase();
    const baseCurrency = String(rule.baseCurrency || 'USD').toUpperCase();
    const basePriceCents = Number(rule.basePriceCents || 0);

    if (!basePriceCents) return 0;
    if (activeCurrency === baseCurrency) return basePriceCents;

    return Math.round(basePriceCents * getCurrencyRate());
  }

  async function getFixedUpsellPriceCents(variantId) {
    const id = String(variantId || '');
    const rule = FIXED_UPSELL_PRICES[id];

    if (!rule) return 0;

    const cacheKey = id + ':' + getActiveCurrency() + ':' + getCurrencyRate();

    if (FIXED_UPSELL_PRICE_CACHE[cacheKey]) {
      return FIXED_UPSELL_PRICE_CACHE[cacheKey];
    }

    try {
      const res = await fetch(`/products/${rule.handle}.js`, { headers: H });

      if (res.ok) {
        const product = await res.json();
        const variant = (product.variants || []).find((v) => String(v.id) === id);
        const apiPrice = Number(variant && variant.price);
        const basePrice = Number(rule.basePriceCents || 0);
        const activeCurrency = String(getActiveCurrency()).toUpperCase();
        const baseCurrency = String(rule.baseCurrency || 'USD').toUpperCase();

        if (
          apiPrice > 0 &&
          (
            activeCurrency === baseCurrency ||
            apiPrice !== basePrice ||
            getCurrencyRate() === 1
          )
        ) {
          FIXED_UPSELL_PRICE_CACHE[cacheKey] = apiPrice;
          return apiPrice;
        }
      }
    } catch (_) {}

    const convertedPrice = getConvertedBasePriceCents(rule);
    FIXED_UPSELL_PRICE_CACHE[cacheKey] = convertedPrice;

    return convertedPrice;
  }

  function fixFixedUpsellPrices() {
    Object.keys(FIXED_UPSELL_PRICES).forEach(async (variantId) => {
      const btn = drawer.querySelector(`.cd-up-add[data-variant="${variantId}"]`);
      if (!btn) return;

      const card = btn.closest('.cd-up-card');
      if (!card) return;

      const priceEl = card.querySelector('.cd-up-price .money, .cd-up-price');
      if (!priceEl) return;

      const cents = await getFixedUpsellPriceCents(variantId);
      if (!cents) return;

      priceEl.textContent = money(cents);
    });
  }

  function scheduleFixedUpsellPriceFix() {
    window.setTimeout(fixFixedUpsellPrices, 0);
    window.setTimeout(fixFixedUpsellPrices, 150);
    window.setTimeout(fixFixedUpsellPrices, 500);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: H });
    const cart = await res.json();

    syncPresentmentCurrency(cart);

    return cart;
  }

  async function changeItem(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: H,
      body: JSON.stringify({ id: key, quantity: qty }),
    });

    return res.json();
  }

  async function addItem(variantId, qty = 1, properties = {}) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: H,
      body: JSON.stringify({ id: String(variantId), quantity: qty, properties }),
    });

    return res.json();
  }

  function clampGiftQuantity(quantity) {
    const qty = Number(quantity || 0);

    if (!Number.isFinite(qty) || qty <= 0) return 0;

    return Math.min(GIFT_MAX_QTY, Math.max(0, Math.floor(qty)));
  }

  function getGiftVariantId(gift) {
    return Number(gift?.variantId || gift?.variant_id || gift?.id || 0);
  }

  function getGiftParentProductId(item) {
    const properties = item?.properties || {};
    return String(properties._parent_product_id || properties.parent_product_id || '').trim();
  }

  function getGiftParentVariantId(item) {
    const properties = item?.properties || {};
    return String(properties._parent_variant_id || properties.parent_variant_id || '').trim();
  }

  function getKnownGiftRules() {
    const rules = [];

    if (Array.isArray(cfg.giftRules)) rules.push(...cfg.giftRules);
    if (window._pendingGiftRule) rules.push(window._pendingGiftRule);
    if (Array.isArray(window.CWGiftRules)) rules.push(...window.CWGiftRules);

    return rules.filter((rule) => {
      return rule && Array.isArray(rule.triggerIds) && Array.isArray(rule.gifts) && rule.gifts.length;
    });
  }

  function getMainQuantityForGift(cart, giftItem) {
    const parentProductId = getGiftParentProductId(giftItem);
    const parentVariantId = getGiftParentVariantId(giftItem);

    if (!parentProductId && !parentVariantId) {
      return clampGiftQuantity(giftItem.quantity || 0);
    }

    const quantity = (cart.items || []).reduce((sum, item) => {
      if (isPP(item) || isGiftItem(item)) return sum;

      const sameVariant = parentVariantId && String(item.variant_id || '') === parentVariantId;
      const sameProduct = !parentVariantId && parentProductId && String(item.product_id || '') === parentProductId;

      return sameVariant || sameProduct ? sum + Number(item.quantity || 0) : sum;
    }, 0);

    return clampGiftQuantity(quantity);
  }

  function getGiftsForMainCartItem(item) {
    const productId = Number(item?.product_id || 0);
    const variantId = Number(item?.variant_id || 0);
    const gifts = new Map();

    getKnownGiftRules().forEach((rule) => {
      const triggerIds = (rule.triggerIds || []).map(Number);

      if (!triggerIds.includes(productId) && !triggerIds.includes(variantId)) return;

      (rule.gifts || []).forEach((gift) => {
        const giftVariantId = getGiftVariantId(gift);

        if (!giftVariantId || giftVariantId === variantId || gifts.has(giftVariantId)) return;

        gifts.set(giftVariantId, gift);
      });
    });

    return Array.from(gifts.values());
  }

  function findLinkedGiftLine(cart, giftVariantId, parentProductId, parentVariantId) {
    const gifts = (cart.items || []).filter((item) => {
      if (!isGiftItem(item)) return false;
      if (Number(item.variant_id || 0) !== Number(giftVariantId || 0)) return false;

      const giftParentVariantId = getGiftParentVariantId(item);
      const giftParentProductId = getGiftParentProductId(item);

      if (parentVariantId && giftParentVariantId) {
        return String(giftParentVariantId) === String(parentVariantId);
      }

      if (parentProductId && giftParentProductId) {
        return String(giftParentProductId) === String(parentProductId);
      }

      return !giftParentVariantId && !giftParentProductId;
    });

    return gifts[0] || null;
  }

  let giftQuantityEnforceBusy = false;

  async function enforceGiftQuantities(cart) {
    if (!cart || giftQuantityEnforceBusy) return cart;

    giftQuantityEnforceBusy = true;

    try {
      let workingCart = cart;
      let changed = false;

      for (const giftItem of (workingCart.items || []).filter(isGiftItem)) {
        const desiredQuantity = getMainQuantityForGift(workingCart, giftItem);
        const currentQuantity = Number(giftItem.quantity || 0);

        if (desiredQuantity === 0) {
          workingCart = await changeItem(giftItem.key, 0);
          changed = true;
          continue;
        }

        if (currentQuantity !== desiredQuantity) {
          workingCart = await changeItem(giftItem.key, desiredQuantity);
          changed = true;
        }
      }

      const mainItems = (workingCart.items || []).filter((item) => !isPP(item) && !isGiftItem(item));

      for (const mainItem of mainItems) {
        const desiredQuantity = clampGiftQuantity(mainItem.quantity || 0);
        if (!desiredQuantity) continue;

        const parentProductId = String(mainItem.product_id || '');
        const parentVariantId = String(mainItem.variant_id || '');
        const gifts = getGiftsForMainCartItem(mainItem);

        for (const gift of gifts) {
          const giftVariantId = getGiftVariantId(gift);
          if (!giftVariantId || String(giftVariantId) === parentVariantId) continue;

          const existingGift = findLinkedGiftLine(workingCart, giftVariantId, parentProductId, parentVariantId);

          if (existingGift) {
            if (Number(existingGift.quantity || 0) !== desiredQuantity) {
              workingCart = await changeItem(existingGift.key, desiredQuantity);
              changed = true;
            }

            continue;
          }

          await addItem(giftVariantId, desiredQuantity, {
            _gift: 'true',
            _parent_product_id: parentProductId,
            _parent_variant_id: parentVariantId,
          });

          workingCart = await fetchCart();
          changed = true;
        }
      }

      return changed ? await fetchCart() : workingCart;
    } catch (error) {
      console.warn('[CartDrawer] Gift quantity sync failed:', error);
      return cart;
    } finally {
      giftQuantityEnforceBusy = false;
    }
  }

  function isPP(item) {
    const handle = String(item?.handle || '').toLowerCase();
    const productType = String(item?.product_type || '').toLowerCase();
    const vendor = String(item?.vendor || '').toLowerCase();

    return (
      PP_HANDLES.includes(handle) ||
      productType.includes('package_protection') ||
      vendor === 're:do'
    );
  }

  function isGiftItem(item) {
    const properties = item?.properties || {};

    if (
      properties._gift === 'true' ||
      properties._gift === true ||
      properties._free_gift === 'true' ||
      properties._free_gift === true
    ) {
      return true;
    }

    if (window.GiftSync?.isGift) return window.GiftSync.isGift(item);

    return false;
  }

  function getVisibleItems(cart) {
    return (cart.items || []).filter((item) => !isPP(item) && !isGiftItem(item));
  }

  function getVisibleItemCount(cart) {
    return getVisibleItems(cart).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  }

  function getPPTotal(cart) {
    return (cart.items || [])
      .filter(isPP)
      .reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
  }

  function getCompareUnitPrice(item) {
    const variantId = String(item.variant_id || '');
    const cached = Number(COMPARE_AT_BY_VARIANT[variantId] || 0);
    const cartCompare = Number(item.compare_at_price || 0);
    const variantCompare = Number(item.variant_compare_at_price || 0);
    const originalUnit = Number(item.original_price || 0);
    const finalUnit = Number(item.final_price || item.price || 0);
    const planCompare = Number(item?.selling_plan_allocation?.compare_at_price || 0);

    return Math.max(
      cached,
      cartCompare,
      variantCompare,
      originalUnit > finalUnit ? originalUnit : 0,
      planCompare
    );
  }

  function getCompareLinePrice(item) {
    if (!item) return 0;

    const finalLine = Number(item.final_line_price || 0);
    const originalLine = Number(item.original_line_price || 0);

    if (finalLine === 0 && originalLine > 0) return originalLine;

    const compareUnit = getCompareUnitPrice(item);
    const compareLine = compareUnit > 0 ? compareUnit * Number(item.quantity || 0) : 0;
    const originalCompareLine = originalLine > finalLine ? originalLine : 0;
    const bestCompareLine = Math.max(compareLine, originalCompareLine);

    return bestCompareLine > finalLine ? bestCompareLine : 0;
  }

  function getDisplayLinePrice(item) {
    return Math.max(getCompareLinePrice(item), Number(item.final_line_price || 0));
  }

  async function hydrateCompareAtPrices(cart) {
    const missingItems = getVisibleItems(cart).filter((item) => {
      const variantId = String(item.variant_id || '');
      return variantId && !Number(COMPARE_AT_BY_VARIANT[variantId] || 0) && item.handle;
    });

    const handles = Array.from(new Set(missingItems.map((item) => item.handle)));

    await Promise.all(
      handles.map(async (handle) => {
        if (PRODUCT_CACHE[handle]) return;

        try {
          const res = await fetch(`/products/${handle}.js`, { headers: H });
          if (!res.ok) return;

          const product = await res.json();
          PRODUCT_CACHE[handle] = product;

          (product.variants || []).forEach((variant) => {
            COMPARE_AT_BY_VARIANT[String(variant.id)] = Number(variant.compare_at_price || 0);
          });
        } catch (_) {}
      })
    );
  }

  let cartOpenTimer = null;
  let cartMutationHoldUntil = 0;
  let cartMutationHoldTimer = null;
  const CART_MUTATION_HOLD_MS = 4500;

  function startCartMutationHold() {
    cartMutationHoldUntil = Date.now() + CART_MUTATION_HOLD_MS;

    if (cartMutationHoldTimer) {
      clearTimeout(cartMutationHoldTimer);
    }

    if (emptyEl) {
      emptyEl.style.display = 'none';
      emptyEl.setAttribute('aria-hidden', 'true');
    }

    setItemsListVisible(true);

    cartMutationHoldTimer = window.setTimeout(() => {
      cartMutationHoldTimer = null;
      cartMutationHoldUntil = 0;
      fetchCart().then(renderAll);
    }, CART_MUTATION_HOLD_MS + 150);
  }

  function stopCartMutationHold(cart) {
    if (getVisibleItems(cart).length === 0) return;

    cartMutationHoldUntil = 0;

    if (cartMutationHoldTimer) {
      clearTimeout(cartMutationHoldTimer);
      cartMutationHoldTimer = null;
    }
  }

  function isCartMutationHoldActive() {
    return Date.now() < cartMutationHoldUntil;
  }

  function hasOptimisticTrustItems() {
    if (!itemsList) return false;

    return !!itemsList.querySelector([
      '[data-optimistic-item]',
      '[data-optimistic="true"]',
      '[data-pending-item]',
      '[data-pending="true"]',
      '.is-optimistic',
      '.cd-item--optimistic'
    ].join(','));
  }

  function hasDrawerItems() {
    return !!itemsList?.querySelector('.cd-item');
  }

  function shouldSuppressEmptyState(cart) {
    if (getVisibleItems(cart).length > 0) return false;

    return isCartMutationHoldActive() || hasOptimisticTrustItems();
  }

  function openDrawer() {
    clearTimeout(cartOpenTimer);

    cartOpenTimer = setTimeout(() => {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--right');
      document.body.style.overflow = 'hidden';

      setTimeout(() => drawer.querySelector('.cd-close')?.focus(), 50);
    }, 800);
  }

  function closeDrawer() {
    clearTimeout(cartOpenTimer);
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--right');
    document.body.style.overflow = '';
  }

  function buildPriceHtml(item) {
    const finalLine = Number(item.final_line_price || 0);
    const isFree = finalLine === 0;
    const isGift = isGiftItem(item);
    const compareLine = getCompareLinePrice(item);
    const isOnSale = compareLine > finalLine;

    if (isGift || isFree) {
      return `<span class="cd-p cd-p-sale">${money(0)}</span>`;
    }

    if (isOnSale) {
      return `<span class="cd-p cd-p-sale">${money(finalLine)}</span>`
        + `<span class="cd-p cd-p-was">${money(compareLine)}</span>`;
    }

    return `<span class="cd-p">${money(finalLine)}</span>`;
  }

  function buildMetaHtml(item) {
    let html = '';

    if (item.variant_title && item.variant_title !== 'Default Title') {
      html += `<p class="cd-item-meta">${esc(item.variant_title)}</p>`;
    }

    if (item.selling_plan_allocation) {
      html += `<p class="cd-item-meta">${esc(item.selling_plan_allocation.selling_plan.name)}</p>`;
      return html;
    }

    Object.entries(item.properties || {}).forEach(([key, value]) => {
      if (!key.startsWith('_') && value) {
        html += `<p class="cd-item-meta">${esc(String(value))}</p>`;
      }
    });

    return html;
  }

  function renderItems(cart) {
    if (!itemsList) return;

    if (shouldSuppressEmptyState(cart)) {
      setItemsListVisible(true);
      removeFreeItemCompareAt();
      return;
    }

    itemsList.innerHTML = '';

    getVisibleItems(cart).forEach((item) => {
      const finalLine = Number(item.final_line_price || 0);
      const originalLine = Number(item.original_line_price || 0);
      const isFree = finalLine === 0 && originalLine > 0;
      const image = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_160x160$1$2') : '';

      const li = document.createElement('li');
      li.className = 'cd-item';
      li.dataset.key = item.key;
      li.dataset.variant = String(item.variant_id || '');

      li.innerHTML = `
        <a href="${item.url}" class="cd-item-thumb" tabindex="-1" aria-hidden="true">
          ${image ? `<img src="${image}" alt="${esc(item.title)}" width="80" height="80" loading="lazy">` : ''}
        </a>

        <div class="cd-item-info">
          <a href="${item.url}" class="cd-item-name">${esc(item.product_title)}</a>
          ${isFree ? '<span class="cd-badge-free">FREE</span>' : ''}
          ${buildMetaHtml(item)}

          <div class="cd-item-foot">
            <div class="cd-qty-widget">
              <button
                type="button"
                class="cd-qbtn"
                data-qty-change
                data-key="${item.key}"
                data-qty="${item.quantity - 1}"
                aria-label="Decrease quantity of ${esc(item.product_title)}"
              >
                <svg width="10" height="2" viewBox="0 0 10 2" fill="none" aria-hidden="true">
                  <path d="M1 1H9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
              </button>

              <span class="cd-qty-val" aria-label="Quantity">${item.quantity}</span>

              <button
                type="button"
                class="cd-qbtn"
                data-qty-change
                data-key="${item.key}"
                data-qty="${item.quantity + 1}"
                aria-label="Increase quantity of ${esc(item.product_title)}"
              >
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                  <path d="M5 1V9M1 5H9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
              </button>
            </div>

            <div class="cd-price-block">${buildPriceHtml(item)}</div>
          </div>
        </div>

        <button
          type="button"
          class="cd-del"
          data-remove
          data-key="${item.key}"
          aria-label="Remove ${esc(item.product_title)} from cart"
        >
          <svg width="13" height="15" viewBox="0 0 13 15" fill="none" aria-hidden="true">
            <path
              d="M1 3.5H12M4.5 3.5V2H8.5V3.5M2 3.5L2.6 13H10.4L11 3.5"
              stroke="currentColor"
              stroke-width="1.3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      `;

      itemsList.appendChild(li);
    });
  }

  function buildLockedGiftQuantityWidget(quantity, title) {
    const qty = Math.max(1, Number(quantity || 1));
    const label = esc(title || 'gift');

    return `
      <div class="cd-qty-widget cd-qty-widget--gift is-locked" aria-label="Quantity of ${label}">
        <button
          type="button"
          class="cd-qbtn"
          disabled
          aria-disabled="true"
          tabindex="-1"
          aria-label="Gift quantity cannot be decreased"
        >
          <svg width="10" height="2" viewBox="0 0 10 2" fill="none" aria-hidden="true">
            <path d="M1 1H9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </button>

        <span class="cd-qty-val" aria-label="Quantity">${qty}</span>

        <button
          type="button"
          class="cd-qbtn"
          disabled
          aria-disabled="true"
          tabindex="-1"
          aria-label="Gift quantity cannot be increased"
        >
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
            <path d="M5 1V9M1 5H9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    `;
  }

  function getGiftQuantityMap(cart) {
    const byKey = {};
    const byVariant = {};

    (cart?.items || []).forEach((item) => {
      if (!isGiftItem(item)) return;

      const key = String(item.key || '');
      const variantId = String(item.variant_id || '');
      const quantity = Math.max(1, Number(item.quantity || 1));

      if (key) byKey[key] = quantity;
      if (variantId) byVariant[variantId] = quantity;
    });

    return { byKey, byVariant };
  }

  function syncGiftQuantityWidgets(cart) {
    if (!itemsList) return;

    const quantityMap = getGiftQuantityMap(cart || window._giftSyncCartCache || null);

    itemsList.querySelectorAll('.cd-item[data-gift-item="true"]').forEach((li) => {
      const key = String(li.dataset.key || '');
      const variantId = String(li.dataset.variant || '');
      const quantity = quantityMap.byKey[key] || quantityMap.byVariant[variantId] || 1;
      const title = li.querySelector('.cd-item-name')?.textContent?.trim() || 'gift';
      const foot = li.querySelector('.cd-item-foot');

      if (!foot) return;

      let widget = foot.querySelector('.cd-qty-widget');

      if (!widget) {
        const priceBlock = foot.querySelector('.cd-price-block');

        if (priceBlock) {
          priceBlock.insertAdjacentHTML('beforebegin', buildLockedGiftQuantityWidget(quantity, title));
        } else {
          foot.insertAdjacentHTML('afterbegin', buildLockedGiftQuantityWidget(quantity, title));
        }

        widget = foot.querySelector('.cd-qty-widget');
      }

      if (!widget) return;

      widget.classList.add('cd-qty-widget--gift', 'is-locked');
      widget.setAttribute('aria-label', `Quantity of ${title}`);

      const qtyEl = widget.querySelector('.cd-qty-val');
      if (qtyEl) qtyEl.textContent = String(quantity);

      widget.querySelectorAll('button').forEach((button) => {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('tabindex', '-1');
        button.removeAttribute('data-qty-change');
        button.removeAttribute('data-key');
        button.removeAttribute('data-qty');
      });
    });
  }

  function renderGifts(cart) {
    if (!itemsList) return;

    itemsList.querySelectorAll('[data-gift-item="true"], .cd-item--gift').forEach((item) => {
      item.remove();
    });

    const giftItems = (cart?.items || []).filter(isGiftItem);

    giftItems.forEach((item) => {
      const image = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_160x160$1$2') : '';
      const title = item.product_title || item.title || 'Free Gift';

      const li = document.createElement('li');
      li.className = 'cd-item cd-item--gift';
      li.dataset.key = item.key;
      li.dataset.variant = String(item.variant_id || '');
      li.dataset.giftItem = 'true';

      li.innerHTML = `
        <span class="cd-item-thumb" aria-hidden="true" style="pointer-events:none;cursor:default;">
          ${image ? `<img src="${image}" alt="${esc(title)}" width="80" height="80" loading="lazy">` : ''}
        </span>

        <div class="cd-item-info">
          <span class="cd-item-name" style="pointer-events:none;cursor:default;">${esc(title)}</span>
          <span class="cd-badge-free">FREE</span>
          ${buildMetaHtml(item)}

          <div class="cd-item-foot">
            ${buildLockedGiftQuantityWidget(item.quantity, title)}

            <div class="cd-price-block">
              <span class="cd-p cd-p-sale">${money(0)}</span>
            </div>
          </div>
        </div>

        <button
          type="button"
          class="cd-del"
          disabled
          aria-disabled="true"
          tabindex="-1"
          aria-label="Gift cannot be removed separately"
        >
          <svg width="13" height="15" viewBox="0 0 13 15" fill="none" aria-hidden="true">
            <path
              d="M1 3.5H12M4.5 3.5V2H8.5V3.5M2 3.5L2.6 13H10.4L11 3.5"
              stroke="currentColor"
              stroke-width="1.3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      `;

      itemsList.appendChild(li);
    });

    syncGiftQuantityWidgets(cart);
  }

  function renderProgress(cart) {
    if (!pfill || !plabel) return;

    // Subscriptions ship free only when no paid one-time item is in the cart; otherwise the whole cart total
    // has to reach the threshold (Rey 2026-10-22). Free gifts ($0) and package protection don't count.
    const items = cart.items || [];
    const hasSubscription = items.some((item) => item.selling_plan_allocation);
    const hasPaidOneTime = items.some((item) => !item.selling_plan_allocation && !isPP(item) && !isGiftItem(item) && Number(item.final_line_price || 0) > 0);
    const baseTotal = Number(cart.total_price || 0) - getPPTotal(cart);
    const isComplete = (hasSubscription && !hasPaidOneTime) || baseTotal >= THRESHOLD;
    const progress = isComplete ? 100 : Math.min(100, Math.floor((baseTotal / THRESHOLD) * 100));

    pfill.style.width = progress + '%';
    pfill.classList.toggle('is-full', isComplete);

    plabel.innerHTML = isComplete
      ? '🎉 Congrats! You\'ve unlocked <strong>FREE SHIPPING!</strong>'
      : `You're <strong>${money(THRESHOLD - baseTotal)}</strong> away from <strong>FREE SHIPPING!</strong>`;
  }

  function renderSubtotal(cart) {
    const visibleItems = getVisibleItems(cart);
    const visibleCount = visibleItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const ppTotal = getPPTotal(cart);
    const visibleCompareTotal = visibleItems.reduce((sum, item) => sum + getDisplayLinePrice(item), 0);
    const total = Number(cart.total_price || 0);
    const compareTotal = visibleCompareTotal + ppTotal;

    if (slabel) {
      slabel.textContent = `Subtotal (${visibleCount} item${visibleCount !== 1 ? 's' : ''})`;
    }

    if (sprice) {
      sprice.textContent = money(total);
    }

    if (scmp) {
      const shouldShowCompare = compareTotal > total;
      scmp.style.display = shouldShowCompare ? '' : 'none';

      if (shouldShowCompare) {
        scmp.textContent = money(compareTotal);
      }
    }
  }

  function setItemsListVisible(isVisible) {
    if (!itemsList) return;

    itemsList.style.display = isVisible ? '' : 'none';
    itemsList.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
  }

  function syncItemsListWithEmptyState() {
    if (!itemsList || !emptyEl) return;

    const emptyIsVisible =
      emptyEl.style.display !== 'none' &&
      !emptyEl.hidden &&
      emptyEl.getAttribute('aria-hidden') !== 'true';

    const hasNonGiftItem = !!itemsList.querySelector('.cd-item:not([data-gift-item="true"])');

    setItemsListVisible(!emptyIsVisible || hasNonGiftItem);
  }

  function renderEmpty(cart) {
    const hasRealItems = getVisibleItems(cart).length > 0;
    const suppressEmpty = shouldSuppressEmptyState(cart);
    const hasDomItems = hasDrawerItems();
    const checkoutBtn = drawer.querySelector('[name="checkout"], [data-checkout], a[href="/checkout"]');

    if (suppressEmpty) {
      if (emptyEl) {
        emptyEl.style.display = 'none';
        emptyEl.setAttribute('aria-hidden', 'true');
      }

      if (footerEl) footerEl.style.display = hasRealItems || hasDomItems ? '' : 'none';

      setItemsListVisible(true);
      removeFreeItemCompareAt();

      if (!checkoutBtn) {
        syncItemsListWithEmptyState();
        return;
      }

      if (hasRealItems || hasDomItems) {
        checkoutBtn.removeAttribute('disabled');
        checkoutBtn.removeAttribute('aria-disabled');
        checkoutBtn.style.pointerEvents = '';
        checkoutBtn.style.opacity = '';
        syncItemsListWithEmptyState();
        return;
      }

      checkoutBtn.setAttribute('disabled', 'disabled');
      checkoutBtn.setAttribute('aria-disabled', 'true');
      checkoutBtn.style.pointerEvents = 'none';
      checkoutBtn.style.opacity = '0.4';

      syncItemsListWithEmptyState();
      return;
    }

    if (emptyEl) {
      emptyEl.style.display = hasRealItems ? 'none' : '';
      emptyEl.setAttribute('aria-hidden', hasRealItems ? 'true' : 'false');
    }

    if (footerEl) footerEl.style.display = hasRealItems ? '' : 'none';

    setItemsListVisible(hasRealItems);

    if (!checkoutBtn) {
      syncItemsListWithEmptyState();
      return;
    }

    if (hasRealItems) {
      checkoutBtn.removeAttribute('disabled');
      checkoutBtn.removeAttribute('aria-disabled');
      checkoutBtn.style.pointerEvents = '';
      checkoutBtn.style.opacity = '';
      syncItemsListWithEmptyState();
      return;
    }

    checkoutBtn.setAttribute('disabled', 'disabled');
    checkoutBtn.setAttribute('aria-disabled', 'true');
    checkoutBtn.style.pointerEvents = 'none';
    checkoutBtn.style.opacity = '0.4';

    syncItemsListWithEmptyState();
  }

  function syncPP(cart) {
    if (!ppBtn) return;

    const ppItems = (cart.items || []).filter(isPP);
    const firstItem = ppItems[0] || null;

    setPPSwitchState(ppItems.length > 0, firstItem?.key || '', firstItem?.variant_id || '');
  }

  function setPPSwitchState(isOn, key, variantId) {
    if (!ppBtn) return;

    ppBtn.classList.toggle('on', !!isOn);
    ppBtn.setAttribute('aria-checked', String(!!isOn));
    ppBtn.dataset.ppKey = key || '';
    ppBtn.dataset.ppVariant = String(variantId || ppBtn.dataset.ppVariant || PP_VARIANT_FALLBACK);
  }

  function callUpsell(cart) {
    if (window.CDUpsell && typeof window.CDUpsell.refresh === 'function') {
      window.CDUpsell.refresh(cart);
      scheduleFixedUpsellPriceFix();
      return;
    }

    window._cdUpsellPending = cart;
  }

  function moneyTextIsFree(text) {
    const raw = String(text || '').replace(/[^0-9]/g, '');
    return raw === '0' || raw === '000';
  }

  function removeFreeItemCompareAt(root = itemsList) {
    if (!root) return;

    root.querySelectorAll('.cd-item').forEach((item) => {
      const priceEl = item.querySelector('.cd-p-sale, .cd-p');
      const isGift =
        item.matches('[data-gift-item="true"], .cd-item--gift') ||
        !!item.querySelector('.cd-badge-free');
      const isFree = isGift || moneyTextIsFree(priceEl?.textContent || '');

      if (!isFree) return;

      item.querySelectorAll('.cd-p-was').forEach((el) => el.remove());

      if (priceEl) {
        priceEl.textContent = money(0);
        priceEl.classList.add('cd-p-sale');
      }
    });
  }

 async function renderAll(cart) {
  syncPresentmentCurrency(cart);
  window._giftSyncCartCache = cart;
  stopCartMutationHold(cart);

  renderItems(cart);
  renderProgress(cart);
  renderSubtotal(cart);
  renderEmpty(cart);
  syncPP(cart);
  callUpsell(cart);
  normalizeDrawerCurrencySymbols();

  await hydrateCompareAtPrices(cart);

  renderItems(cart);
  renderGifts(cart);
  removeFreeItemCompareAt();
  renderSubtotal(cart);
  renderEmpty(cart);
  removeFreeItemCompareAt();
  scheduleFixedUpsellPriceFix();
  normalizeDrawerCurrencySymbols();

  return cart;
}

  document.getElementById('cd-btn-close')?.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener(
    'click',
    (event) => {
      const addTrigger = event.target.closest(
        '[data-add-to-cart], [data-upsell-add], [data-up-add], .cd-up-add'
      );

      if (!addTrigger) return;

      startCartMutationHold();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(
        '.js-drawer-open-cart, [data-drawer-toggle="CartDrawer"], [href="/cart"], [href="{{ routes.cart_url }}"]'
      );

      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();

      fetchCart().then(renderAll).then(openDrawer);
    },
    true
  );

 document.addEventListener('cart:updated', (event) => {
  const cart = event.detail?.cart;
  const shouldOpenAfterUpdate = isCartMutationHoldActive();

  const afterRender = () => {
    if (shouldOpenAfterUpdate && !drawer.classList.contains('is-open')) {
      openDrawer();
    }
  };

  if (cart) {
    enforceGiftQuantities(cart).then(renderAll).then(afterRender);
    return;
  }

  fetchCart().then(enforceGiftQuantities).then(renderAll).then(afterRender);
});

  if (itemsList && emptyEl) {
    new MutationObserver(syncItemsListWithEmptyState).observe(emptyEl, {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });

    new MutationObserver(syncItemsListWithEmptyState).observe(itemsList, {
      childList: true,
      subtree: false
    });
  }

  if (itemsList) {
    let giftQtySyncScheduled = false;

    function scheduleGiftQuantitySync() {
      if (giftQtySyncScheduled) return;

      giftQtySyncScheduled = true;

      requestAnimationFrame(() => {
        giftQtySyncScheduled = false;
        syncGiftQuantityWidgets(window._giftSyncCartCache || null);
      });
    }

    new MutationObserver(scheduleGiftQuantitySync).observe(itemsList, {
      childList: true,
      subtree: true
    });
  }

  if (itemsList) {
    let freeCompareCleanupScheduled = false;

    function scheduleFreeCompareCleanup() {
      if (freeCompareCleanupScheduled) return;

      freeCompareCleanupScheduled = true;

      requestAnimationFrame(() => {
        freeCompareCleanupScheduled = false;
        removeFreeItemCompareAt();
      });
    }

    new MutationObserver(scheduleFreeCompareCleanup).observe(itemsList, {
      childList: true,
      subtree: true
    });
  }

  itemsList?.addEventListener('click', async (event) => {
    const qtyBtn = event.target.closest('[data-qty-change]');

    if (qtyBtn) {
      if (qtyBtn.disabled || qtyBtn.closest('[data-gift-item="true"]')) return;

      qtyBtn.closest('.cd-item')?.classList.add('is-busy');

      const nextQty = Math.max(0, Number(qtyBtn.dataset.qty));
      const cart = await changeItem(qtyBtn.dataset.key, nextQty);
      const syncedCart = await enforceGiftQuantities(cart);

      renderAll(syncedCart);
      return;
    }

    const removeBtn = event.target.closest('[data-remove]');

    if (removeBtn) {
      removeBtn.closest('.cd-item')?.classList.add('is-busy');

      const cart = await changeItem(removeBtn.dataset.key, 0);
      const syncedCart = await enforceGiftQuantities(cart);

      renderAll(syncedCart);
    }
  });

  function parseMoneyToCents(value) {
    let str = String(value || '').trim().replace(/[^\d.,-]/g, '');
    const hasComma = str.includes(',');
    const hasDot = str.includes('.');

    if (hasComma && hasDot) {
      str = str.lastIndexOf(',') > str.lastIndexOf('.')
        ? str.replace(/\./g, '').replace(',', '.')
        : str.replace(/,/g, '');
    } else if (hasComma) {
      str = str.replace(/\./g, '').replace(',', '.');
    }

    const number = parseFloat(str);

    return Number.isNaN(number) ? 0 : Math.round(number * 100);
  }

  function formatMoneyFromPattern(currentText, cents) {
    const fixed = (Math.abs(cents) / 100).toFixed(2);
    let decimal = '.';
    let thousand = ',';

    if (currentText.includes(',') && currentText.includes('.')) {
      if (currentText.lastIndexOf(',') > currentText.lastIndexOf('.')) {
        decimal = ',';
        thousand = '.';
      }
    } else if (currentText.includes(',') && !currentText.includes('.')) {
      decimal = ',';
      thousand = '.';
    }

    let [integerPart, decimalPart] = fixed.split('.');
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousand);

    const formatted = integerPart + decimal + decimalPart;
    const currency = (String(currentText).match(/[^\d.,\s-]+/) || ['$'])[0];
    const currencyIndex = String(currentText).search(/[^\d.,\s-]/);
    const digitIndex = String(currentText).search(/\d/);

    return currencyIndex !== -1 && currencyIndex < digitIndex
      ? currency + formatted
      : formatted + currency;
  }

  function optimisticSubtotalPP(wasOn) {
    if (!sprice || !ppBtn) return;

    const ppPrice = Number(ppBtn.dataset.ppPrice || 0);
    if (!ppPrice) return;

    const currentSubtotal = parseMoneyToCents(sprice.textContent);
    const nextSubtotal = wasOn
      ? Math.max(0, currentSubtotal - ppPrice)
      : currentSubtotal + ppPrice;

    sprice.textContent = formatMoneyFromPattern(sprice.textContent, nextSubtotal);

    if (scmp && scmp.style.display !== 'none') {
      const currentCompare = parseMoneyToCents(scmp.textContent);
      const nextCompare = wasOn
        ? Math.max(0, currentCompare - ppPrice)
        : currentCompare + ppPrice;

      scmp.textContent = formatMoneyFromPattern(scmp.textContent, nextCompare);
    }
  }

  async function enforceSinglePP(mode) {
    await wait(150);

    let cart = await fetchCart();

    for (let i = 0; i < 8; i++) {
      const ppItems = (cart.items || []).filter(isPP);

      if (mode === 'none') {
        if (ppItems.length === 0) return cart;

        for (const item of ppItems) {
          await changeItem(item.key, 0);
        }
      }

      if (mode === 'one') {
        if (ppItems.length === 1) return cart;

        if (ppItems.length === 0) {
          await addItem(ppBtn?.dataset.ppVariant || PP_VARIANT_FALLBACK, 1);
        } else {
          for (let j = 1; j < ppItems.length; j++) {
            await changeItem(ppItems[j].key, 0);
          }
        }
      }

      await wait(300);
      cart = await fetchCart();
    }

    return cart;
  }

  let ppBusy = false;

  ppBtn?.addEventListener('click', () => {
    if (ppBusy) return;

    ppBusy = true;

    const isOn = ppBtn.classList.contains('on') || ppBtn.getAttribute('aria-checked') === 'true';

    optimisticSubtotalPP(isOn);
    setPPSwitchState(!isOn, '', '');

    setTimeout(() => {
      ppBusy = false;
    }, 300);

    (async () => {
      try {
        const cart = await enforceSinglePP(isOn ? 'none' : 'one');
        renderAll(cart);
      } catch (_) {
        renderAll(await fetchCart());
      }
    })();
  });

  function setDiscountMsg(text, isError = false) {
    if (!dcMsg) return;

    dcMsg.textContent = text;
    dcMsg.style.display = text ? '' : 'none';
    dcMsg.classList.toggle('err', isError);
  }

  dcApply?.addEventListener('click', () => {
    const code = (dcInput?.value || '').trim().toUpperCase();

    if (!code) {
      setDiscountMsg('Please enter a discount code.', true);
      return;
    }

    sessionStorage.setItem('cd_discount', code);
    setDiscountMsg(`Code "${code}" will be applied at checkout.`);
  });

function getInstantCheckoutUrl() {
  const code = (sessionStorage.getItem('cd_discount') || '').trim();

  if (!code) return '/checkout';

  return '/checkout?discount=' + encodeURIComponent(code);
}

function goToInstantCheckout() {
  window.location.href = getInstantCheckoutUrl();
}

document.addEventListener(
  'click',
  (event) => {
    const trigger = event.target.closest(
      '[name="checkout"], [data-checkout], a[href="/checkout"]'
    );

    if (!trigger || !drawer.contains(trigger)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    goToInstantCheckout();
  },
  true
);

document.getElementById('CartDrawerForm')?.addEventListener('submit', (event) => {
  event.preventDefault();
  event.stopPropagation();

  goToInstantCheckout();
});

  (function installRogueDOMGuard() {
    if (!itemsList) return;

    function purgeRogueFreeNodes() {
      itemsList.querySelectorAll('.cd-item:not([data-gift-item="true"])').forEach((li) => {
        const priceEl = li.querySelector('.cd-p-sale, .cd-p');
        if (!priceEl) return;

        const raw = priceEl.textContent.replace(/[^\d]/g, '');

        if (raw !== '0' && raw !== '000') return;

        const variantId = Number(li.dataset.variant || 0);

        if (window.GiftSync?.isGift && window._giftSyncCartCache) {
          const cartItem = (window._giftSyncCartCache.items || [])
            .find((item) => Number(item.variant_id) === variantId);

          if (cartItem && window.GiftSync.isGift(cartItem)) {
            li.remove();
          }
        }
      });
    }

    new MutationObserver(purgeRogueFreeNodes).observe(itemsList, { childList: true });
  })();

  (function installFixedUpsellPriceObserver() {
    let scheduled = false;

    function scheduleFix() {
      if (scheduled) return;

      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        fixFixedUpsellPrices();
        normalizeDrawerCurrencySymbols();
      });
    }

    new MutationObserver(scheduleFix).observe(drawer, {
      childList: true,
      subtree: true
    });

    document.addEventListener('cart:updated', scheduleFix);

    document.addEventListener(
      'click',
      (event) => {
        if (
          event.target.closest(
            '[data-upsell-add],[data-up-add],[data-add-to-cart],[data-drawer-toggle="CartDrawer"],[href="/cart"]'
          )
        ) {
          scheduleFix();
        }
      },
      true
    );

    scheduleFix();
  })();

  const API = {
    open: openDrawer,
    close: closeDrawer,
    refresh: (cart) => cart ? renderAll(cart) : fetchCart().then(renderAll),
    isGiftItem,
  };

  window.CartDrawer = API;

  try {
    if (window.theme) {
      window.theme.cartDrawer = API;
    } else {
      let themeProxy = {};

      Object.defineProperty(window, 'theme', {
        configurable: true,
        get() {
          return themeProxy;
        },
        set(value) {
          themeProxy = value;

          if (value && !value.cartDrawer) {
            value.cartDrawer = API;
          }
        },
      });
    }
  } catch (_) {}

  fetchCart().then(renderAll);
})();